export class CookiesNames
{
    public static AKAMAI_TOKEN: string = "SXMAKTOKEN";
    public static LIME_LIGHT_TOKEN: string = "SXMLLTOKEN";
}
